import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon, MinusIcon } from "lucide-react"
import { motion } from "motion/react"

import { cn } from "@aw/lib"

function Checkbox({
    className,
    testId,
    ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & { testId?: string }) {
    return (
        <div className={cn(
            "relative flex items-center justify-center size-[30px] rounded-full transition-colors shrink-0",
            !props?.disabled ? "hover:bg-hover" : "",
            className
        )}>
            <CheckboxPrimitive.Root
                data-slot="checkbox"
                data-testid={testId}
                className={cn(
                    // AWOPS-3003 — fixed 18px box, border 1.5px gunmetal-500, radius 4px.
                    // Checked fill = purple-400 (#7A5FFF), NOT purple-base (#6F54EB); color-palette.ts is stale/inverted.
                    "peer relative cursor-pointer dark:bg-input/30 group focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-[18px] shrink-0 rounded-[4px] border-[1.5px] shadow-xs transition-all duration-200 ease-out outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed border-muted-foreground",
                    props?.checked
                        ? "bg-purple-400 border-purple-400 disabled:bg-space-cadet-200 disabled:border-space-cadet-200 disabled:opacity-50"
                        : "disabled:border-space-cadet-200 disabled:opacity-50",
                    props?.checked === "indeterminate"
                        ? "bg-purple-400 border-purple-400 disabled:bg-space-cadet-200 disabled:border-space-cadet-200 disabled:opacity-50"
                        : ""
                )}
                {...props}
            >
                <CheckboxPrimitive.Indicator
                    data-slot="checkbox-indicator"
                    className="flex items-center z-[1] justify-center text-current"
                    asChild
                >
                    <motion.div
                        initial={{ scale: 0, opacity: 0, x: -2 }}
                        animate={{ scale: 1, opacity: 1, x: 0 }}
                        exit={{ scale: 0, opacity: 0, x: -2 }}
                        transition={{
                            type: "spring",
                            stiffness: 500,
                            damping: 25,
                            duration: 0.2
                        }}
                        className="flex items-center justify-center"
                    >
                        <motion.div
                            initial={{ pathLength: 0 }}
                            animate={{ pathLength: 1 }}
                            transition={{
                                duration: 0.3,
                                ease: "easeOut",
                                delay: 0.05
                            }}
                        >
                            {props?.checked === "indeterminate" ? (
                                <MinusIcon className="size-3 text-lavender-50 dark:text-foreground-on-accent" />
                            ) : (
                                <CheckIcon className="size-3 text-lavender-50 dark:text-foreground-on-accent" />
                            )}
                        </motion.div>
                    </motion.div>
                </CheckboxPrimitive.Indicator>
            </CheckboxPrimitive.Root>
        </div>
    )
}

export { Checkbox }
